// frontend/src/components/ObfuscatedEmail.tsx
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  u: string;     // user, e.g., "info"
  d: string;     // domain, e.g., "elani-energy.com"
  className?: string;
  linkText?: string; // optional custom text; defaults to "user [at] domain"
};

/**
 * Obfuscates an email address in the UI and only constructs mailto: on click
 * to reduce scraping by crawlers while keeping the address human-usable.
 */
export function ObfuscatedEmail({ u, d, className, linkText }: Props) {
  const onClick = useCallback(() => {
    const addr = `${u}@${d}`;
    window.location.href = `mailto:${addr}`;
  }, [u, d]);

  const { t } = useTranslation();

  const display = linkText ?? `${u} [at] ${d.replace(/\./g, " [dot] ")}`;

  return (
    <button
      type="button"
      onClick={onClick}
      className={className ?? "underline underline-offset-2 hover:no-underline"}
      aria-label={t("common.reveal_email")}
    >
      {display}
      <span className="sr-only">{u}@{d}</span>
    </button>
  );
}